module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89a5687599f173f2b910aa5fcd862b42.svg";